import React from 'react';
import { Route, withRouter } from 'react-router';
import VtypeList from "./components/vtypeList";
import { Container } from 'semantic-ui-react'


const Vtype = () => {
    return (
        <>
            <Route path="/vtype/list" component={withRouter(VtypeList)} />
        </>
    )
};

export default Vtype;

